"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function newReturning(criteria, services) {
    var value = criteria[0].values[0];
    var storage = services.localStorage;
    var stored = storage.get('firstVisit');
    if (stored === null) {
        return value === 'new';
    }
    var now = new Date();
    var firstVisit = new Date(stored);
    var diff = now.valueOf() - firstVisit.valueOf();
    var diffInHours = (diff / (1000 * 3600));
    switch (value) {
        case 'new':
            return diffInHours <= 1;
        case 'returning':
            return diffInHours > 1;
        default:
            return false;
    }
}
exports.default = newReturning;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibmV3UmV0dXJuaW5nLmpzIiwic291cmNlUm9vdCI6InNyYy8iLCJzb3VyY2VzIjpbInNyYy9saWIvc2VydmljZXMvdGFyZ2V0cy9uZXdSZXR1cm5pbmcudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFHQSxTQUF3QixZQUFZLENBQUUsUUFBa0MsRUFBRSxRQUFzQjtJQUM1RixJQUFNLEtBQUssR0FBRyxRQUFRLENBQUMsQ0FBQyxDQUFDLENBQUMsTUFBTSxDQUFDLENBQUMsQ0FBQyxDQUFBO0lBQ25DLElBQU0sT0FBTyxHQUFHLFFBQVEsQ0FBQyxZQUFZLENBQUE7SUFDckMsSUFBTSxNQUFNLEdBQUcsT0FBTyxDQUFDLEdBQUcsQ0FBQyxZQUFZLENBQUMsQ0FBQTtJQUV4QyxJQUFJLE1BQU0sS0FBSyxJQUFJLEVBQUU7UUFDakIsT0FBTyxLQUFLLEtBQUssS0FBSyxDQUFBO0tBQ3pCO0lBRUQsSUFBTSxHQUFHLEdBQUcsSUFBSSxJQUFJLEVBQUUsQ0FBQTtJQUN0QixJQUFNLFVBQVUsR0FBRyxJQUFJLElBQUksQ0FBQyxNQUFnQixDQUFDLENBQUE7SUFDN0MsSUFBTSxJQUFJLEdBQUcsR0FBRyxDQUFDLE9BQU8sRUFBRSxHQUFHLFVBQVUsQ0FBQyxPQUFPLEVBQUUsQ0FBQTtJQUNqRCxJQUFNLFdBQVcsR0FBRyxDQUFDLElBQUksR0FBRyxDQUFDLElBQUksR0FBRyxJQUFJLENBQUMsQ0FBQyxDQUFBO0lBRTFDLFFBQVEsS0FBSyxFQUFFO1FBQ1gsS0FBSyxLQUFLO1lBQ04sT0FBTyxXQUFXLElBQUksQ0FBQyxDQUFBO1FBQzNCLEtBQUssV0FBVztZQUNaLE9BQU8sV0FBVyxHQUFHLENBQUMsQ0FBQTtRQUMxQjtZQUNJLE9BQU8sS0FBSyxDQUFBO0tBQ25CO0FBQ0wsQ0FBQztBQXRCRCwrQkFzQkMifQ==